// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DigitaleSouveraenitaetRouteImport } from './routes/digitale-souveraenitaet'
import { Route as DigitaleDemokratieRouteImport } from './routes/digitale-demokratie'
import { Route as DigitalSovereigntyRouteImport } from './routes/digital-sovereignty'
import { Route as DigitalDemocracyRouteImport } from './routes/digital-democracy'
import { Route as PreviewRouteRouteImport } from './routes/preview/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LanguageKeyIndexRouteImport } from './routes/$languageKey/index'
import { Route as EnDigitalSovereigntyRouteImport } from './routes/en.digital-sovereignty'
import { Route as EnDigitalDemocracyRouteImport } from './routes/en.digital-democracy'
import { Route as DeDigitaleSouveraenitaetRouteImport } from './routes/de.digitale-souveraenitaet'
import { Route as DeDigitaleDemokratieRouteImport } from './routes/de.digitale-demokratie'
import { Route as PreviewVersionIdRouteImport } from './routes/preview/$versionId'
import { Route as LanguageKeyTopicSlugIndexRouteImport } from './routes/$languageKey/$topicSlug/index'
import { Route as LanguageKeyLegalLegalPageRouteImport } from './routes/$languageKey/legal/$legalPage'
import { Route as LanguageKeyTopicSlugPageSlugIndexRouteImport } from './routes/$languageKey/$topicSlug/$pageSlug/index'
import { Route as LanguageKeyTopicSlugPageSlugVersionIdIndexRouteImport } from './routes/$languageKey/$topicSlug/$pageSlug/$versionId/index'

const DigitaleSouveraenitaetRoute = DigitaleSouveraenitaetRouteImport.update({
            id: '/digitale-souveraenitaet',path: '/digitale-souveraenitaet',getParentRoute: () => rootRouteImport
          })
const DigitaleDemokratieRoute = DigitaleDemokratieRouteImport.update({
            id: '/digitale-demokratie',path: '/digitale-demokratie',getParentRoute: () => rootRouteImport
          })
const DigitalSovereigntyRoute = DigitalSovereigntyRouteImport.update({
            id: '/digital-sovereignty',path: '/digital-sovereignty',getParentRoute: () => rootRouteImport
          })
const DigitalDemocracyRoute = DigitalDemocracyRouteImport.update({
            id: '/digital-democracy',path: '/digital-democracy',getParentRoute: () => rootRouteImport
          })
const PreviewRouteRoute = PreviewRouteRouteImport.update({
            id: '/preview',path: '/preview',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LanguageKeyIndexRoute = LanguageKeyIndexRouteImport.update({
            id: '/$languageKey/',path: '/$languageKey/',getParentRoute: () => rootRouteImport
          })
const EnDigitalSovereigntyRoute = EnDigitalSovereigntyRouteImport.update({
            id: '/en/digital-sovereignty',path: '/en/digital-sovereignty',getParentRoute: () => rootRouteImport
          })
const EnDigitalDemocracyRoute = EnDigitalDemocracyRouteImport.update({
            id: '/en/digital-democracy',path: '/en/digital-democracy',getParentRoute: () => rootRouteImport
          })
const DeDigitaleSouveraenitaetRoute = DeDigitaleSouveraenitaetRouteImport.update({
            id: '/de/digitale-souveraenitaet',path: '/de/digitale-souveraenitaet',getParentRoute: () => rootRouteImport
          })
const DeDigitaleDemokratieRoute = DeDigitaleDemokratieRouteImport.update({
            id: '/de/digitale-demokratie',path: '/de/digitale-demokratie',getParentRoute: () => rootRouteImport
          })
const PreviewVersionIdRoute = PreviewVersionIdRouteImport.update({
            id: '/$versionId',path: '/$versionId',getParentRoute: () => PreviewRouteRoute
          })
const LanguageKeyTopicSlugIndexRoute = LanguageKeyTopicSlugIndexRouteImport.update({
            id: '/$languageKey/$topicSlug/',path: '/$languageKey/$topicSlug/',getParentRoute: () => rootRouteImport
          })
const LanguageKeyLegalLegalPageRoute = LanguageKeyLegalLegalPageRouteImport.update({
            id: '/$languageKey/legal/$legalPage',path: '/$languageKey/legal/$legalPage',getParentRoute: () => rootRouteImport
          })
const LanguageKeyTopicSlugPageSlugIndexRoute = LanguageKeyTopicSlugPageSlugIndexRouteImport.update({
            id: '/$languageKey/$topicSlug/$pageSlug/',path: '/$languageKey/$topicSlug/$pageSlug/',getParentRoute: () => rootRouteImport
          })
const LanguageKeyTopicSlugPageSlugVersionIdIndexRoute = LanguageKeyTopicSlugPageSlugVersionIdIndexRouteImport.update({
            id: '/$languageKey/$topicSlug/$pageSlug/$versionId/',path: '/$languageKey/$topicSlug/$pageSlug/$versionId/',getParentRoute: () => rootRouteImport
          })





const PreviewRouteRouteChildren = {
  PreviewVersionIdRoute: PreviewVersionIdRoute
}

const PreviewRouteRouteWithChildren = PreviewRouteRoute._addFileChildren(PreviewRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,PreviewRouteRoute: PreviewRouteRouteWithChildren,DigitalDemocracyRoute: DigitalDemocracyRoute,DigitalSovereigntyRoute: DigitalSovereigntyRoute,DigitaleDemokratieRoute: DigitaleDemokratieRoute,DigitaleSouveraenitaetRoute: DigitaleSouveraenitaetRoute,DeDigitaleDemokratieRoute: DeDigitaleDemokratieRoute,DeDigitaleSouveraenitaetRoute: DeDigitaleSouveraenitaetRoute,EnDigitalDemocracyRoute: EnDigitalDemocracyRoute,EnDigitalSovereigntyRoute: EnDigitalSovereigntyRoute,LanguageKeyIndexRoute: LanguageKeyIndexRoute,LanguageKeyLegalLegalPageRoute: LanguageKeyLegalLegalPageRoute,LanguageKeyTopicSlugIndexRoute: LanguageKeyTopicSlugIndexRoute,LanguageKeyTopicSlugPageSlugIndexRoute: LanguageKeyTopicSlugPageSlugIndexRoute,LanguageKeyTopicSlugPageSlugVersionIdIndexRoute: LanguageKeyTopicSlugPageSlugVersionIdIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)